/* Elysian FAQ motion (2026-09-30). Loaded by sections/elysian-faq.liquid. Native details/summary underneath: without this file, or
   with reduced motion, the questions open and close instantly and the CSS reads [open].
   With it, the list is marked data-ely-faq-js and .is-open drives the look (assets/elysian-faq.css). The height is a measured-height
   transition: the panel's height runs from where it is to the answer's measured height (open, 480ms) or to 0 (close, 360ms); the
   durations and curve come from the CSS, so the computed styles show them. At the end of an open the inline height is dropped (auto,
   the same number, so nothing moves). grid-template-rows 0fr to 1fr was tried first and does not animate in Firefox inside details.
   [open] is set before an open and dropped after a close. Mouse, Enter and Space all arrive as a click on the summary; a click
   mid-run reverses from where it is; a toggle from elsewhere (find in page, the editor) is taken as is. */
(function () {
  if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SAFETY_MS = 700;
  function bind(list) {
    if (list.hasAttribute('data-ely-faq-js')) return;
    var items = list.querySelectorAll('details.ely-faq__item');
    Array.prototype.forEach.call(items, function (d) { if (d.open) d.classList.add('is-open'); });
    list.setAttribute('data-ely-faq-js', '');
    Array.prototype.forEach.call(items, function (d) {
      var summary = d.querySelector('summary');
      var panel = d.querySelector('.ely-faq__panel');
      var inner = d.querySelector('.ely-faq__panel-inner');
      if (!summary || !panel || !inner) return;
      var timer = null, busy = false;
      function done() {
        clearTimeout(timer); timer = null; busy = false;
        if (d.classList.contains('is-open')) { panel.style.height = ''; }
        else { d.open = false; panel.style.height = ''; }
      }
      function run(open) {
        var from = panel.getBoundingClientRect().height;
        busy = true;
        clearTimeout(timer);
        panel.style.height = from + 'px';
        void panel.offsetHeight;
        d.classList.toggle('is-open', open);
        panel.style.height = (open ? inner.getBoundingClientRect().height : 0) + 'px'; /* the layout height: scrollHeight would add the answer's 4px start offset */
        timer = setTimeout(done, SAFETY_MS);
      }
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var opening = !d.classList.contains('is-open');
        if (opening && !d.open) {
          busy = true;
          d.open = true; /* the panel renders at 0 (closed style) for this frame, then grows */
          requestAnimationFrame(function () { if (!d.classList.contains('is-open')) run(true); });
        } else {
          run(opening);
        }
      });
      panel.addEventListener('transitionend', function (e) {
        if (e.target === panel && e.propertyName === 'height') done();
      });
      d.addEventListener('toggle', function () {
        if (busy || d.open === d.classList.contains('is-open')) return;
        panel.style.height = '';
        d.classList.toggle('is-open', d.open);
      });
    });
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('.ely-faq-v2 .ely-faq__list'), bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
